import React from 'react'

import { CurrentRiskProductsCards } from './Cards'

export const RiskProductTabs = () => {
  return (
    <CurrentRiskProductsCards />
  )
}
